(() => {
  const parsePrice = (card) => {
    const n = Number(card.dataset.price || '');
    return Number.isFinite(n) ? n : Infinity;
  };
  const parseStars = (card) => {
    const n = Number(card.dataset.stars || '0');
    return Number.isFinite(n) ? n : 0;
  };
  const hasBreakfast = (card) => card.dataset.breakfast === '1';
  const hasFlexible = (card) => card.dataset.flexible === '1';

  document.querySelectorAll('[data-bat-hbx-search]').forEach(root => {
    const results = root.querySelector('[data-bat-hbx-results]');
    const filters = root.querySelector('[data-bat-hbx-filters]');
    if (!results || !filters || filters.dataset.ready === '1') return;
    filters.dataset.ready = '1';

    const sort = filters.querySelector('[data-bat-filter-sort]');
    const stars = filters.querySelector('[data-bat-filter-stars]');
    const price = filters.querySelector('[data-bat-filter-price]');
    const breakfast = filters.querySelector('[data-bat-filter-breakfast]');
    const flexible = filters.querySelector('[data-bat-filter-flexible]');
    const reset = filters.querySelector('[data-bat-filter-reset]');
    const count = filters.querySelector('[data-bat-filter-count]');

    let originalOrder = [];

    const apply = () => {
      const cards = [...results.querySelectorAll('.bat-hbx-card')];
      if (!cards.length) {
        filters.hidden = true;
        if (count) count.textContent = '';
        return;
      }
      filters.hidden = false;
      if (!originalOrder.length) originalOrder = [...cards];

      const minStars = Number(stars?.value || 0);
      const maxPrice = Number(price?.value || 0);
      const requireBreakfast = !!breakfast?.checked;
      const requireFlexible = !!flexible?.checked;

      const visible = cards.filter(card => {
        if (minStars && parseStars(card) < minStars) return false;
        if (maxPrice && parsePrice(card) > maxPrice) return false;
        if (requireBreakfast && !hasBreakfast(card)) return false;
        if (requireFlexible && !hasFlexible(card)) return false;
        return true;
      });

      visible.sort((a,b) => {
        switch (sort?.value) {
          case 'price-asc': return parsePrice(a) - parsePrice(b);
          case 'price-desc': return parsePrice(b) - parsePrice(a);
          case 'stars-desc': return parseStars(b) - parseStars(a) || parsePrice(a) - parsePrice(b);
          case 'name-asc': return (a.querySelector('h3')?.textContent || '').localeCompare(b.querySelector('h3')?.textContent || '');
          default: return originalOrder.indexOf(a) - originalOrder.indexOf(b);
        }
      });

      cards.forEach(card => { card.hidden = !visible.includes(card); });
      visible.forEach(card => results.appendChild(card));
      if (count) count.textContent = visible.length + ' of ' + cards.length + ' shown';
      root.dispatchEvent(new CustomEvent('bat:hbx-filtered',{detail:{visible:visible.length,total:cards.length}}));
    };

    const refresh = () => {
      originalOrder = [...results.querySelectorAll('.bat-hbx-card')];
      const catalogMode = root.dataset.dataMode === 'catalog';
      if (price) {
        price.disabled = catalogMode;
        if (catalogMode) price.value='0';
      }
      if (breakfast) {
        breakfast.disabled = catalogMode;
        if (catalogMode) breakfast.checked=false;
      }
      if (flexible) {
        flexible.disabled = catalogMode;
        if (catalogMode) flexible.checked=false;
      }
      if (sort) {
        [...sort.options].forEach(option => {
          if (option.value==='price-asc' || option.value==='price-desc') option.disabled=catalogMode;
        });
        if (catalogMode && (sort.value==='price-asc' || sort.value==='price-desc')) sort.value='recommended';
      }
      apply();
    };

    filters.addEventListener('change', apply);
    reset?.addEventListener('click', () => {
      if (sort) sort.value='recommended';
      if (stars) stars.value='0';
      if (price) price.value='0';
      if (breakfast) breakfast.checked=false;
      if (flexible) flexible.checked=false;
      apply();
    });

    root.addEventListener('bat:hbx-results-ready', refresh);
    if (results.querySelector('.bat-hbx-card')) refresh();
  });
})();